export default __webpack_public_path__ + "static/media/shape-24.24d8d672.png";